<template>
  <div class="m-wrapper">
    <div class="title">
      <p class="title-text">账号密码登录</p>
    </div>
    <div class="main">
      <div class="main-input">
        <van-cell-group>
          <van-field
            v-model="loginInfo.account"
            left-icon="contact"
            clearable
            type="tel"
            label="用户名"
            right-icon="question-o"
            placeholder="请输入用户名"
            @click-right-icon="$toast('请输入用户名（手机号）！')"
            autocomplete="off"
          />
          <van-field
            v-model="loginInfo.password"
            left-icon="setting-o"
            type="password"
            label="密码"
            inputmode="url"
            right-icon="question-o"
            placeholder="请输入密码"
            @click-right-icon="$toast('密码为6位以上数字或字符！')"
            autocomplete="off"
          />
        </van-cell-group>
        <p class="seti forget-p">
          <span href @click="openModal()">忘记密码？</span>
        </p>

        <button class="m-bt" @click="toLogin">登&nbsp;录</button>
      </div>
      <p class="seti regi">
        <router-link :to="{name:'register'}">注&nbsp;册</router-link>
      </p>
      <p class="seti policy">
        登录即代表您已同意
        <a href="/user/policy" class="c-378BD3">srccLims注册协议与隐私政策</a>
      </p>
    </div>
    <van-dialog
      v-model="forgetPw"
      title="重设密码"
      show-cancel-button
      @confirm="modalSave()"
      @cancel="closeModal()"
    >
      <div class="content">
        <div class="sc-content-wrapper">
          <van-field v-model="renewPw.account" type="tel" label="手机号" clearable />
          <van-field v-model="renewPw.code" center clearable label="短信验证码" placeholder="请输入短信验证码">
            <template #button>
              <van-button
                size="small"
                type="primary"
                :disabled="codeStat"
                @click="getAccessCode"
              >{{codeText}}</van-button>
            </template>
          </van-field>
          <van-field
            v-model="renewPw.pwa"
            type="password"
            label="密码"
            placeholder="输入新的密码"
            clearable
          />
          <van-field
            v-model="renewPw.pwb"
            type="password"
            label="密码"
            placeholder="再次输入新的密码"
            clearable
          />
        </div>
      </div>
    </van-dialog>
  </div>
</template>
<script>
function pwFac() {
  return {
    account: "",
    code: "",
    pwa: "",
    pwb: "",
  };
}
export default {
  name: "systemLogin",
  components: {},
  data() {
    return {
      loginInfo: {
        account: "",
        password: "",
      },
      forgetPw: false,
      codeStat: false,
      codeText: "获取验证码", //3秒后可重新获取
      renewPw: pwFac(),
    };
  },
  props: {},
  created() {},
  mounted() {},
  computed: {
    loginValid: function () {
      if (this.loginInfo.account === "") {
        return false;
      } else if (this.loginInfo.password === "") {
        return false;
      } else {
        return true;
      }
    },
  },
  methods: {
    //非空验证
    handleRewrite() {
      this.errorFlag.isCode = false;
    },
    openModal() {
      if (/^\d{11}$/.test(this.loginInfo.account)) {
        this.renewPw.account = this.loginInfo.account;
      }
      this.forgetPw = true;
    },
    closeModal() {
      this.forgetPw = false;
    },
    modalSave() {
      if (!/^\d{11}$/.test(this.renewPw.account)) {
        this.$toast({
          message: "手机号为空或格式不符",
          duration: 6,
        });
      } else if (!/^\d{6}$/.test(this.renewPw.code)) {
        this.$toast({
          message: "验证码为空或格式不符，应为6位数字",
          duration: 6,
        });
      } else if (!/^[@#$%^&*()_.+!a-zA-Z0-9]{6,18}$/.test(this.renewPw.pwa)) {
        this.$toast({
          message:
            "密码为空或格式不符，应为6~18位数字或英文字母（可包含特殊字符）",
          duration: 6,
        });
      } else if (this.renewPw.pwa !== this.renewPw.pwb) {
        this.$toast({
          message: "两次密码不相同，请重新设置",
          duration: 6,
        });
      } else {
        this.$axios
          .post(this.$url + "/alter_password_by_code", {
            val: this.renewPw,
          })
          .then((response) => {
            if (response.data.stat === "ok") {
              this.$toast.success("密码修改成功！");
              this.closeModal();
              this.renewPw = pwFac();
            } else {
              this.$toast.fail({
                message: "密码修改失败，验证码错误或已过期",
                duration: 6,
              });
              this.renewPw = pwFac();
            }
          })
          .catch((error) => {
            this.$toast(error);
          });
      }
    },
    getAccessCode() {
      if (/^\d{11}$/.test(this.renewPw.account)) {
        let initialVal = 60;
        this.codeStat = true;
        this.codeText = initialVal + "秒后可重新获取";
        let tmpId = setInterval(() => {
          if (initialVal > 1) {
            initialVal = initialVal - 1;
            this.codeText = initialVal + "秒后可重新获取";
          } else {
            this.codeStat = false;
            this.codeText = "获取验证码";
            clearInterval(tmpId);
          }
        }, 1000);
        this.$axios
          .post(this.$url + "/access_code", {
            val: this.renewPw,
          })
          .then((response) => {
            if (response.data.stat === "ok") {
              this.$Message.success("验证码发送成功，有效期5分钟！");
            } else {
              this.$toast({
                message: response.data.info,
                duration: 15,
              });
            }
          })
          .catch((error) => {
            this.$toast(error);
          });
      } else {
        this.$toast("手机号为空或格式不符，请重新填写！");
      }
    },
    toLogin() {
      if (this.loginValid) {
        this.$axios
          .post(this.$url + "/login", {
            val: this.loginInfo,
          })
          .then((response) => {
            if (response.data.error_info !== "") {
              this.$toast("登录失败！" + response.data.error_info);
            } else {
              localStorage.setItem(
                "current_user_token",
                response.data.user_token
              );
              let resAuthData = {
                barRights: response.data.barRights,
                sfileRight: response.data.sfileRight,
                expireTime: Date.now() + 1000 * 3600 * 4,
              };
              localStorage.setItem("authData", JSON.stringify(resAuthData));
              let url = localStorage.getItem("urlBeforeLogin");
              if(url!==undefined){
                window.location.href = url;
                return
              }
              window.location.href = "/index";
            }
          })
          .catch((error) => {
            this.$toast("出现错误：" + error);
          });
      } else {
        this.$toast("用户名或密码不能为空！请仔细核对！");
      }
    },
  },
};
</script>


<style scoped>
.m-wrapper {
  text-align: center;
  min-height: 460px;
}
.main {
  width: 90%;
  margin: 0 auto;
}
.title-text {
  text-align: center;
  font-size: 25px;
  font-weight: 800;
  color: #000;
  padding: 30px 0 50px 0;
}

.regi {
  border: 1px solid #003e94;
  background: #fff;
  border-radius: 3px;
  cursor: pointer;
  height: 2.1rem;
  font-size: 0.85rem;
  line-height: 2.1rem;
  font-weight: 700;
}

.m-bt {
  width: 100%;
  margin: 0 auto;
  outline: none;
  border: none;
  border-radius: 3px;
  cursor: pointer;
  height: 2.25rem;
  font-size: 0.9rem;
  line-height: 2.25rem;
  background: #003e94;
  color: #fff;
}

p {
  margin: 0.5rem 0;
}
.forget-p {
  font-size: 0.7rem;
  text-align: right;
}

.policy {
  font-size: 0.6rem;
}

.policy a {
  color: blue;
}

input:internal-autofill-selected {
  -webkit-box-shadow: 0 0 0px 1000px white inset;
}
</style>